import { React, useState, useEffect, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import { RaiseRequestContext } from "../../../Contexts/RaiseRequestContext";
import HeaderButton from "./HeaderButton";
import lock from "../../../images/lock-icon.png";
import { CurrencyContext } from "../../../Contexts/CurrencyContext";
import ExcelDownloader from "../../shared/ExcelDownloader";
import { exportExcel, getRequestsQuota } from "../../../Config/config";
import useModule from "../../../hooks/useModule";
import Constants from "../../../Constants";
import { UserContext } from "../../../Contexts/UserContext";
import { Tooltip } from "antd";
import CurrencyComponent from "../../Financial/CurrencyComponent";
import CurrencyTypeComponent from "../../Financial/CurrencyTypeComponent";
import LockIcon from "mdi-react/LockIcon";
import ConfirmPopup from "../../../Utils/ConfirmPopup";
import { TableHeaderContext } from "../../../Contexts/TableHeaderContext";
import { map } from "lodash";
import { TableDataContext } from "../../../Contexts/TableDataContext";
import axios from "axios";
import { faArrowUpLong } from "@fortawesome/free-solid-svg-icons";

import { AiOutlineInfoCircle } from "react-icons/ai";
/* Collapsible cash flow icons (ec09dbb) - disabled
import { AiOutlineInfoCircle, AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
*/

/* The above code is a React component written in JavaScript. It is a statement component for
displaying financial data. */
function PLStatement({
  data,
  profile,
  isDetails,
  setIsDetail,
  companyName,
  openTab,
  // isExport,
  companyLabel,
  cfsFinKeys,
  fCompanyName,
  menu,
  cfsId
}) {
  const [selected, setSelected] = useState(2);
  const [alert, setalert] = useState({ message: "", show: false });
  const [alertRequest, setalertRequest] = useState({ message: "", show: false });
  const { openRequestPopup } = useContext(RaiseRequestContext);
  const {forExRate, setForExRate, nonXBRLFypeStandalone, nonXBRLFypeConsolidated} = useContext(TableDataContext);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipTimer, setTooltipTimer] = useState(null);
  const { primaryMasterId, isPE, isVC, isMA } = useModule();

  /* Collapsible cash flow sections (ec09dbb) - disabled
  const [collapsedGroups, setCollapsedGroups] = useState({});

  const toggleGroup = (group) => {
    setCollapsedGroups((prev) => ({ ...prev, [group]: !prev[group] }));
  };

  const visibleFinKeys = cfsFinKeys.filter(({ group }) => !collapsedGroups[group]);

  const renderLabel = (label, collapsible) =>
    collapsible ? (
      <button
        type="button"
        onClick={() => toggleGroup(collapsible)}
        className="inline-flex items-center gap-2"
      >
        {label}
        {collapsedGroups[collapsible] ? (
          <AiOutlinePlus className="text-base shrink-0" />
        ) : (
          <AiOutlineMinus className="text-base shrink-0" />
        )}
      </button>
    ) : (
      label
    );
  */

  const consolidatedData = data?.filter(
    (data) => data.fin_type === "Consolidated"
  ).sort((a, b) => parseInt(b.fy) - parseInt(a.fy));
  

  const standaloneData = data?.filter((data) => data.fin_type === "Standalone").sort((a, b) => parseInt(b.fy) - parseInt(a.fy));

  // Function to check if current FY data is available
  const isCurrentFYDataAvailable = () => {
    if(isPE || isVC || isMA){
      return true;
    }
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11
    
    // Determine current FY based on Indian financial year (April to March)
    const currentFY = currentMonth >= 4 ? currentYear : currentYear - 1;
    
    // Convert current FY from YYYY to YY format to match data format
    const currentFYInYY = currentFY % 100;
    
    // Check if company is LLP (based on CIN starting with "AA" or listing_status "LLP") or BFSI industry
    // For these companies, we want to show the update button, so return false
    if(profile?.cin?.startsWith("AA") || profile?.listing_status === "LLP" || profile?.industry === "BFSI"){
      console.log("Company is LLP or BFSI - showing update button");
      return true;
    }
    
    // Get the active dataset based on selected type
    const activeData = selected === 1 ? consolidatedData : standaloneData;
    
    // Check if the most recent data is for current FY
    if (activeData && activeData.length > 0) {
      const mostRecentFY = parseInt(activeData[0].fy);
      return mostRecentFY >= currentFYInYY;
    }
    
    return false;
  };

  const allowedModulesStr = localStorage.getItem(Constants.localStorageKeys.allowedModules);
  const allowedModulesList = JSON.parse(allowedModulesStr) ?? [];
  
  const { currencyType, currency, setFinancialType } =
    useContext(CurrencyContext);
  const { companyId } = useParams();

  const { isDirectoryUser, isTrialExport, getAllowedModules } = useContext(UserContext);
  const allowedModules = getAllowedModules();

  let companyProfileId = parseInt(companyId);
  const isExport = localStorage.getItem(Constants.localStorageKeys.isExport) === 'true';
  const isStudent = localStorage.getItem(Constants.localStorageKeys.studentLogin) === 'true';

  console.log(isExport, isStudent, "chec")

  /**
   * The function `onButtonSelect` updates the selected and financial type based on the selected
   * type.
   */
  const onButtonSelect = (selectedType) => {
    setSelected(selectedType);
    setFinancialType(selectedType === 1 ? "Consolidated" : "Standalone");
  };

  const exportRequest = useMemo(() => {
    if (openTab === 1) {
      return {
        sub_section: ["plstandard"],
        sub_section_type: selected === 1 ? "PL-Consolidated" : "PL-Standalone",
        fileName:
          selected === 1
            ? Constants.exportNames.plConsolidated(fCompanyName || companyName)
            : Constants.exportNames.plStandalone(fCompanyName || companyName),
      };
    } else if (openTab === 2) {
      return {
        sub_section: ["balancesheet"],
        sub_section_type: selected === 1 ? "BS-Consolidated" : "BS-Standalone",
        fileName:
          selected === 1
            ? Constants.exportNames.balanceSheetCon(fCompanyName || companyName)
            : Constants.exportNames.balanceSheetStandalone(fCompanyName || companyName),
      };
    } else {
      return {
        sub_section: ["cashflow"],
        sub_section_type: selected === 1 ? "CF-Consolidated" : "CF-Standalone",
        fileName:
          selected === 1
            ? Constants.exportNames.cashflowCon(fCompanyName || companyName)
            : Constants.exportNames.cashflowStandalone(fCompanyName || companyName),
      };
    }
  }, [companyName, fCompanyName, openTab, selected]);

  const onBlurColumnClick = () => {
    setalert({
      show: true,
      message: Constants.cfsSubscriptionMsg,
      isAlertOnly: true,
      closeBtnName: "OK",
    });
  };

  const onConfirmation = (flag) => {
    setalert({ show: false, message: "" });
  };

  const addCommasToNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const raiseRequestConfirmation = (n) => { 
    if (n === 0) {
      setalertRequest({ show: false, message: "" });
      return
    }

    openRequestPopup("updateFinancialsAutomation", "CFS")
    setalertRequest({ show: false, message: "" });
  }


  const handleRaiseRequestAutomation = () => {
    setalertRequest({
      show: true,
      message: 'Checking your Custom requests quota.. Please wait..',
      isAlertOnly: true,
      closeBtnName: "Cancel",
      icon: " "
    });
    const url = `${getRequestsQuota}?email=${localStorage.getItem(Constants.localStorageKeys.loggedInEmail)}`
    axios(url)
      .then((response) => {
        const infoText = response.data.quota > 1 ? `You have ${response.data.quota} available requests. Proceeding with your data update will deduct 1 request from your total.` : "You have no available requests quota left. Please renew or upgrade your subscription to continue." 
        setalertRequest({
          show: true,
          message: infoText,
          isAlertOnly: response.data.quota < 1,
          closeBtnName: "Cancel",
          activeBtnName: "Confirm",
          icon: " "
        });
      })
      .catch(error => { console.error('Error fetching data:', error.message); });
  }

  function changeCurrencyType(fy, val, USDinM, INRinC, INRinL, INRinM) {
    let showInUSD = val;
    const usdValue = forExRate?.find(item => item?.fy === fy)?.value;
    
    if (currencyType === 'USD') {
      if (usdValue) {
          showInUSD /= parseFloat(usdValue);
      } 
    }

    let divByval = 1;
  
    if (currencyType === 'INR' && currency === 'C') {
        divByval = INRinC;
    } else if(currencyType === 'INR' && currency === 'L'){
        divByval = INRinL;
    }
    else if(currencyType === 'INR' && currency === 'M'){
        divByval = INRinM;
    }
     else if (currencyType === 'USD' && currency === 'M') {
        divByval = USDinM;
    }

    const totval = showInUSD / divByval;
    let formattedValue;

    if (currency === 'A') {
        formattedValue = divByval == 1 ? val : totval; // Don't divide if divByval is 1, because it removes decimal values
    } else {
        formattedValue = totval.toFixed(2); // Apply toFixed(2) for other cases
    }

    return addCommasToNumber(formattedValue);
  }
  
  useEffect(()=>{
    console.log('currencyType changed')
  }, [currency, currencyType]);
  
  // Handle mouse enter on info icon
  const handleMouseEnter = () => {
    if (tooltipTimer) clearTimeout(tooltipTimer);
    setTooltipVisible(true);
  };
  
  // Handle mouse leave from info icon
  const handleMouseLeave = () => {
    // Set a timeout before hiding the tooltip to give user time to move to the tooltip
    const timer = setTimeout(() => {
      setTooltipVisible(false);
    }, 300); // 300ms delay
    setTooltipTimer(timer);
  };
  
  // Keep tooltip visible when mouse enters the tooltip content
  const handleTooltipMouseEnter = () => {
    if (tooltipTimer) clearTimeout(tooltipTimer);
    setTooltipVisible(true);
  };
  
  // Hide tooltip when mouse leaves the tooltip content
  const handleTooltipMouseLeave = () => {
    setTooltipVisible(false);
  };
  
  // Clean up any pending timers when component unmounts
  useEffect(() => {
    return () => {
      if (tooltipTimer) clearTimeout(tooltipTimer);
    };
  }, [tooltipTimer]);

  const excludedStandloneLabels = [
    "Profit (loss) of minority interest",
    // "Profit (loss) for period",
    "Share of profit (loss) in associates",
    "Minority interest",
    "Total profit (loss) for period before minority interest"
  ];

  return (
    <div>
      <div className="flex items-center justify-between px-3 md:px-5">
        <div className="flex items-center space-x-2">
        {(selected === 2 && openTab !== 3 && nonXBRLFypeStandalone?.length > 0 || selected === 1 && nonXBRLFypeConsolidated?.length > 0)  && (

        <div className="relative inline-block">
            <AiOutlineInfoCircle 
              className="text-black cursor-pointer text-lg" 
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
            {/* Tooltip */}
            {tooltipVisible &&  (
              <div 
                className="absolute z-10 whitespace-nowrap text-[13px] bg-white border border-gray-300 text-black rounded-md px-3 py-2 shadow-lg top-6 left-0 pointer-events-auto"
                onMouseEnter={handleTooltipMouseEnter}
                onMouseLeave={handleTooltipMouseLeave}
              >
                {selected === 2 ? nonXBRLFypeStandalone : nonXBRLFypeConsolidated} figures are based on AOC-4 filings. Let us know if you'd like us to {" "}
                <span
                  className="text-[#bc8b20] underline cursor-pointer"
                  onClick={() => openRequestPopup("AOC", "AOC")}
                >
                  cross-check
                </span>{" "}
                with the Annual Report document.
              </div>
            )}
          </div>
        )}
          <div className="flex items-center space-x-2 md:space-x-3">
            {standaloneData?.length != 0 && standaloneData != null ? (
              <div className="py-4">
                <HeaderButton
                  isSelected={selected === 2}
                  onClick={(e) => onButtonSelect(2)}
                >
                  Standalone
                </HeaderButton>
              </div>
            ) : (
              <></>
            )}
            {consolidatedData?.length != 0 && consolidatedData != null ? (
              <div className="">
                <HeaderButton
                  isSelected={selected === 1}
                  onClick={(e) => onButtonSelect(1)}
                >
                  Consolidated
                </HeaderButton>
              </div>
            ) : (
              <></>
            )}
          </div>
          {companyLabel && (
              <div className="rounded-full bg-purple-100 px-2.5 py-[0.1rem] text-[9px] leading-[12px] font-sans_book_body text-[#333333]">
                XBRL
              </div>
            )}
        </div>

        <div>
          {(openTab === 1 || openTab === 2 || openTab === 3) && data?.length != 0 && 
            <div className="flex items-center md:justify-center justify-between">
                {/* {!isCurrentFYDataAvailable() && (
                  <button className="mr-4 text-amber-700 underline" onClick={handleRaiseRequestAutomation}>Request for latest financials</button>
                )} */}
                <div className="flex items-center mr-4">
                  <CurrencyTypeComponent />
                  <span className="md:mx-3 mx-1">in</span>
                  <CurrencyComponent />
                </div>
              {(!isStudent) && isExport && allowedModulesList.includes('cfs') ? (
                  <ExcelDownloader
                    url={exportExcel}
                    fileName={exportRequest.fileName}
                    data={{
                      export_from: "detail",
                      module_type: "investments",
                      section: "financials",
                      type: 5,
                      is_detailed: isDetails,
                      currency_cd: currencyType,
                      display_in: currency,
                      company_id: menu === "cfs" ? [companyProfileId] : [cfsId],
                      sub_section: exportRequest.sub_section,
                      sub_section_type: exportRequest.sub_section_type,
                    }}
                  />
                ) : null}
            </div>
          }
        </div>
      </div>
      {selected === 1 && consolidatedData?.length != 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="text-[12pt] leading-[15pt] bg-[#EDEDED] lg:text-[13px] lg:leading-[15px] font-bold text-[#666666] py-4 px-0 text-left">
              <tr>
                <th
                  width={`${isDetails ? "23%" : '10%'}`}
                  className="whitespace-nowrap px-5 py-3.5 text-left sticky left-0 bg-[#EDEDED]"
                >
                  Financials
                </th>
                {consolidatedData?.map((data, index) => (
                  <th width={`${consolidatedData?.length-1 === index ? '5':'8%'}`} className={`${consolidatedData?.length - 1 === index ? "px-5" : "px-2"} py-3`}>
                    <div className={`flex justify-center text-center ${consolidatedData?.length-1 === index ? currency === "A" ? 'w-28' : currency === "L" ? "w-[5.5rem]" : 'w-20' :"w-auto" }`}>
                      FY{data.fy}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-[12pt] leading-[15pt] lg:text-[12px] lg:leading-[15px] text-[#666666] py-4 px-0 text-left">
              {cfsFinKeys.map(({ accessor, label, USDinM, INRinC, INRinL, INRinM, style }) => (
              /* {visibleFinKeys.map(({ accessor, label, USDinM, INRinC, INRinL, INRinM, style, collapsible }) => ( */
                <tr
                  key={label}
                  /* key={accessor || label} */
                  className="border-b font-sans_book_body text-[#333333] leading-[24px] text-[14px]"
                >
                  <td className={`${style} md:whitespace-nowrap font-sans_book_body px-5 py-3 text-left sticky left-0 bg-white text-[#333333] w-[3rem]`}>
                    {label}
                    {/* {renderLabel(label, collapsible)} */}
                  </td>
                  {consolidatedData?.map((year, index) => (
                    <td
                        key={`${accessor}-${year.fy}`}
                        className={`${style} md:whitespace-nowrap font-sans_book_body px-5 py-3 bg-white text-[#333333] w-[2rem]`}
                      >
                        <div className={`text-center ${consolidatedData?.length-1 === index ? currency === "A" ? 'w-40' : currency === "L" ? "w-[5.5rem]" : 'w-20' : !year[accessor]
                              ? "w-4"
                              : "w-auto" }`}>
                        {year[accessor] === 0 || year[accessor] === null || !year[accessor]
                          ? ""
                          : changeCurrencyType(year.fy, year[accessor], USDinM, INRinC, INRinL, INRinM)}
                        </div>
                      </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : selected === 2 && standaloneData?.length != 0 ? (
        <div className="overflow-auto">
          <table className="w-full">
            <thead className="text-[12pt] leading-[15pt] bg-[#EDEDED] lg:text-[13px] lg:leading-[15px] font-medium text-[#666666] py-4 px-0 text-left">
              <tr>
                <th width={`${isDetails ? "25%" : '10%'}`}
                  className="whitespace-nowrap px-5 py-3.5 text-left sticky left-0 top-0 bg-[#EDEDED]">
                  Financials
                </th>
                {standaloneData?.map((fin, index) => {
                  return (
                    <th width={`${standaloneData?.length - 1 === index ? "5" : "8%"}`}
                      className={`${standaloneData?.length - 1 === index ? "px-5" : "px-2"} py-3`}
                      key={index}
                    >
                        {fin?.fy && (
                          <div className={`flex justify-center text-center ${standaloneData?.length - 1 === index ? currency === "A" ? 'w-40' : currency === "L" ? "w-[5.5rem]" : 'w-20' : "w-auto"}`}>
                          {`FY${fin.fy}`}
                          </div>
                        )}

                      </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="text-[12pt] leading-[15pt] lg:text-[12px] lg:leading-[15px] text-[#666666] py-4 px-0 text-left">
              {cfsFinKeys.map(({ accessor, label, USDinM, INRinC, INRinL, INRinM, style }) => (
              /* {visibleFinKeys.map(({ accessor, label, USDinM, INRinC, INRinL, INRinM, style, collapsible }) => ( */
                !excludedStandloneLabels.includes(label) && (
                <tr
                  key={label}
                  /* key={accessor || label} */
                  className="border-b font-sans_book_body text-[#333333] leading-[24px]  text-[14px]"
                >
                  <td className={`${style} md:whitespace-nowrap font-sans_book_body px-5 py-3 text-left sticky left-0  bg-white text-[#333333] w-[3rem]`}>
                    {label}
                    {/* {renderLabel(label, collapsible)} */}
                  </td>
                  {standaloneData?.map((year, index) => (
                    <td
                        key={`${accessor}-${year.fy}`}
                        className={`${style} md:whitespace-nowrap font-sans_book_body px-5 py-3 text-left bg-white text-[#333333] w-[2rem]`}
                      >
                        <div className={`text-center ${standaloneData?.length-1 === index ? currency === "A" ? 'w-28' : currency === "L" ? "w-[5.5rem]" : 'w-20' : !year[accessor]
                              ? "w-4"
                              : "w-auto" }`}>
                          {year[accessor] === 0 || year[accessor] === null || !year[accessor] ? "" : changeCurrencyType(year.fy, year[accessor],USDinM, INRinC, INRinL, INRinM)}
                        </div>
                      </td>
                  ))}
                </tr>
                )
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="h-28 w-full">
          <div className="w-full h-full flex items-center justify-center">
            {/* <img className='w-10 h-10' src={AlertGif} alt="" />     */}
            <p className="px-5 text-[14px]">
                Data not found. Please{" "}
                <button
                  className="text-[#A5711A] hover:underline"
                  onClick={() => openRequestPopup("financial", "CFS")}
                  >
                  Click Here
                </button>{" "}
                to alert Venture Intelligence about this. Thanks
              </p>
          </div>
        </div>
      )}
      {consolidatedData?.length === 0 && standaloneData?.length === 0 || isDetails ? <></> : 
        <div className="flex">
                  <button
                      onClick={(e) => {
                          e.preventDefault();
                          setIsDetail(true)
                      }}
                      className=" py-1 px-2 border rounded-[5px] border-[#D2D2D2] inline-flex items-center float-right mx-3 my-3"
                  >
                      {!allowedModules.includes("cfs") && <img src={lock} alt='' />}
                      <span className="pl-2 pr-1 text-[#333333] text-[13px]">
                          Detailed
                      </span>
                  </button>
            </div>
        }
      {<ConfirmPopup {...alert} onChange={onConfirmation} />}
      {<ConfirmPopup {...alertRequest} onChange={raiseRequestConfirmation} />}
    </div>
  );
}

export default PLStatement;